import { useState } from "react";
import { api } from "@/lib/api";
import { formatApiError } from "@/lib/formatApiError";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { MessageSquareOff } from "lucide-react";

const ITEMS = [
  { key: "sav_client_reminder", label: "Rappel la veille d'un SAV" },
  { key: "sav_client_on_the_way", label: "« Le technicien arrive »" },
  { key: "order_planned_client", label: "Chantier planifié" },
];

// Interrupteurs « SMS activé » ; l'API stocke l'inverse (sms_opt_out = true => SMS coupé)
export const ClientSmsPreferences = ({ clientKey, initial, onChange }) => {
  const [optOut, setOptOut] = useState({ sav_client_reminder: false, sav_client_on_the_way: false, order_planned_client: false, ...(initial || {}) });
  const [busy, setBusy] = useState(false);

  const toggle = async (key, enabled) => {
    const next = { ...optOut, [key]: !enabled };
    setBusy(true);
    try {
      await api.updateClientSmsPreferences(clientKey, next);
      setOptOut(next);
      onChange?.(next);
      toast.success(enabled ? "SMS réactivé pour ce client" : "SMS coupé pour ce client");
    } catch (err) {
      toast.error(formatApiError(err, "Enregistrement impossible"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="md:col-span-2 mt-2 pt-2 border-t" data-testid="client-sms-preferences">
      <p className="text-xs font-semibold text-muted-foreground mb-1.5 flex items-center gap-1">
        <MessageSquareOff className="h-3.5 w-3.5" /> SMS automatiques pour ce client
      </p>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {ITEMS.map((it) => (
          <label key={it.key} className="flex items-center gap-2 text-xs cursor-pointer">
            <Switch checked={!optOut[it.key]} onCheckedChange={(v) => toggle(it.key, v)} disabled={busy}
              data-testid={`client-sms-toggle-${it.key}`} />
            {it.label}
          </label>
        ))}
      </div>
    </div>
  );
};
